export default __webpack_public_path__ + "static/media/screen_1_bottom.410e80f5.png";